import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzNrday65 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_NRDAY_65: Record<
  Exclude<PageIdWoofzNrday65, PageIdWoofzNrday65.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_NRDAY_65_N]: {
    id: PageId.SUBSCRIPTIONS_NRDAY_65_N,
  },
  [PageId.CHAT_UPSELL_NRDAY_65]: {
    id: PageId.CHAT_UPSELL_NRDAY_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_NRDAY_65]: {
    id: PageId.UPSELL_NRDAY_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_NRDAY_65]: {
    id: PageId.DOWNLOAD_NRDAY_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
